import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-label",
  templateUrl: "./med-icon-label.component.html",
})
export class MedIconLabelComponent extends SvgMixinComponent {}
